// Form data types
export interface JoinRequestAnswer {
  questionId: number;
  answer: string | number | boolean | string[];
}

export interface JoinRequestFormData {
  fullName: string;
  phoneNumber: string;
  birthDate: string;
  answers: JoinRequestAnswer[];
}

// API response types
export interface JoinRequestResponse {
  id: number;
  fullName: string;
  birthDate: string;
  status: string;
  mosqueId: number;
  createdAt: string;
  updatedAt: string;
}

export interface ApiError {
  statusCode: number;
  message: string;
  error: string;
}

// Form validation error types
export interface FormErrors {
  fullName?: string;
  birthDate?: string;
  phoneNumber?: string;
}

// Form state types
export type FormState = 'idle' | 'loading' | 'success' | 'error';

// Environment configuration
export interface Config {
  apiBaseUrl: string;
}

export enum QuestionType {
  TEXT = 'text',
  BOOLEAN = 'boolean',
}

export interface Question {
  id: number;
  question: string;
  description?: string;
  type: QuestionType;
  isRequired: boolean;
  group: string;
} 